export default class ApplicationStatus {
  static SERVICE_NAME = 'applicationStatus';

  constructor({ app }) {
    this.axios = {
      withToken() {
        return app.$axios.create({
          baseURL : process.env.APPLICATION_STATUS_SERVICE_API,
          headers : {
            Accept         : 'application/json',
            'Content-Type' : 'application/json',
            'x-api-key'    : process.env.APPLICATION_STATUS_SERVICE_API_KEY,
            Authorization  : app.$token.get()
          }
        });
      }
    };
  }

  getAll(params) {
    return this.axios.withToken().get('/applications', { params });
  }
}
